import { Review } from "../../@types/types";
import * as S from "./styled";
import { Star } from "@phosphor-icons/react";

interface CardsAssessmentsProps {
    data: Review;
}

export default function CardsAssessments({ data }: CardsAssessmentsProps) {

    const formatDate = (dateString: string) => {
        const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString(undefined, options);
    }

    const renderRatingStars = (rating: number) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <Star
                    key={i}
                    weight={i < rating ? 'fill' : 'regular'}
                    size={12}
                    color={i < rating ? '#FFD700' : '#E0E0E0'}
                />
            );
        }
        return stars;
    }

    return (
        <S.Container>
            <S.ContainerImg>
                <S.Logo src={data.userImage} alt="user" />
                <S.Title>{data.userName}</S.Title>
            </S.ContainerImg>
            <S.ExtraInfo>
                <S.Rating>
                    {renderRatingStars(data.score)}
                </S.Rating>
                <S.Date>{formatDate(data.date)}</S.Date>
            </S.ExtraInfo>
            <S.SubContainer>
                <S.Description>{data.text}</S.Description>
            </S.SubContainer>
        </S.Container>
    );
}
